<template>
  <v-container
  align-center
  fluid
  >
    <v-layout
    align-center
    justify-space-around
    column
    >
      <v-flex
        xs6
        sm6
        md6
        lg6

        offset-xs3
        offset-sm3
        offset-md3

        ma-12
        pa-5
      >
        <router-link
          to="/"
        >
          <v-img
            :src="require('../assets/404.svg')"
            max-width="1074"
            max-height="400"
            alt="Error 404: Page Not Found"
            contain
          ></v-img>
        </router-link>
      </v-flex>
      <h1>Page Not Found</h1>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
